import { useMutation } from '@tanstack/react-query';
import { diContainer } from 'src/inversify.config';
import DiscountCouponRepository from 'src/features/discountCoupons/data/DiscountCouponsRepository';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import useTrackCouponEvents from 'src/features/discountCoupons/presentation/hooks/useTrackCouponEvents';

const discountCouponRepository = diContainer.get<DiscountCouponRepository>(
  DiscountCouponRepository
);

type CouponMutationParams = {
  couponCode: string;
};

export default function useDiscountCouponMutations() {
  const { session } = useAuthContext();
  const { trackRemoveCoupon, trackAddCoupon } = useTrackCouponEvents();

  const applyCouponToCartMutation = useMutation({
    mutationKey: ['applyCouponToCart'],
    mutationFn: ({ couponCode }: CouponMutationParams) =>
      discountCouponRepository.applyToCart({
        couponCode,
        accessToken: session?.accessToken as string,
      }),
    onSuccess: (cartCoupon) => {
      cartCoupon && trackAddCoupon(cartCoupon);
    },
  });

  const removeCouponFromCartMutation = useMutation({
    mutationKey: ['removeCouponFromCart'],
    mutationFn: ({ couponCode }: CouponMutationParams) =>
      discountCouponRepository.removeFromCart({
        couponCode,
        accessToken: session?.accessToken as string,
      }),
    onSuccess: (cartCoupon, { couponCode }) => {
      cartCoupon && trackRemoveCoupon({ couponCode, removed: true });
    },
  });

  return {
    removeCouponFromCartMutation,
    applyCouponToCartMutation,
  };
}
